import { useSiteImage } from "../../hooks/useSettings";

export const LogoBadge = ({ compact = false }) => {
    const logo = useSiteImage("img_logo", "/assets/brand/mero-logo.jpg");

    return (
        <div className="flex items-center gap-3" data-testid="logo-badge">
            <div className="bg-white rounded-xl px-1.5 py-1 shadow-[0_4px_20px_rgba(0,0,0,0.5)] w-16 h-12 flex items-center justify-center overflow-hidden">
                <img
                    src={logo}
                    alt="Mero — شركة إطار الثريا لخدمات السيارات"
                    className="w-full h-full object-contain"
                />
            </div>
            {!compact && (
                <div className="leading-tight">
                    <p className="font-display font-bold text-white text-sm sm:text-base">
                        شركة إطار الثريا لخدمات السيارات
                    </p>
                    <p className="font-mono-spec text-[10px] tracking-widest text-amber-400/90">
                        AL THURAYA TIRE AUTO SERVICES CO
                    </p>
                </div>
            )}
        </div>
    );
};
